import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../shared/types';
import { handleError } from '../../../ui/err/handleError';
import TableUnit from './TableUnit';
import * as C from '../../../ui/common/CommonStyles';
import { Group, Pagination } from '@mantine/core';
import CustomSearch from '../../../ui/search/customSearch';
import { useCustomSearch } from '../../../../shared/hook/useCustomSearch';
import { cleanParams } from '../../../../shared/utils/cleanParams';
import { relayPointApis } from '../../../../shared/apis/relayPoint/apis';

const options = [
  { value: 'all', label: 'All' },
  { value: 'userId', label: '아이디' },
  { value: 'username', label: '이름' },
];

const DataPoint = () => {
  const navigate = useNavigate();
  // 클라이언트단 url parameter 설정
  const [searchParams, setSearchParams] = useSearchParams('');
  const searchWord = searchParams.get('keyword') || '';
  const searchType = searchParams.get('searchType') || 'all';
  const page = searchParams.get('page') || '1';
  const size = searchParams.get('size') || '10';

  const { inputRef, handleSearch, resetWord, handleSearchType, resetSearchInput } = useCustomSearch({
    initType: 'all',
  });

  // 데이터 포인트 회원 목록 조회 쿼리
  const { data: getDataPointUserQuery } = useQuery(
    ['loadDataPointUserQuery', Number(page), Number(size), searchType, searchWord],
    () =>
      relayPointApis.getDataPointUser({
        size: Number(size),
        page: Number(page),
        isAsc: false,
        searchType: searchType,
        keyword: searchWord,
        sortBy: 'createdat',
      }),
    {
      refetchOnWindowFocus: false,
      onError: (error: AxiosError<AxiosCommonError>) => {
        handleError(error);
      },
    },
  );

  // 페이지네이션 처리를 위한 토탈값
  const total: number = getDataPointUserQuery?.data.totalElements;

  const onClickNavigate = (id: string) => {
    return () => {
      navigate(`/admin/datapoint/${id}`);
    };
  };

  return (
    <div>
      <C.TitleBox>
        <div className="title">데이터 포인트 회원관리</div>
      </C.TitleBox>
      <C.ListBox>
        <C.Toolbar>
          <CustomSearch
            resetSearch={resetWord}
            resetSearchInput={resetSearchInput}
            searchType={searchType}
            setSearchType={handleSearchType}
            inputRef={inputRef}
            handleSearch={handleSearch}
            searchOptions={options}
          />
        </C.Toolbar>
        <C.TableWrap>
          <TableUnit data={getDataPointUserQuery} onClickNavigate={onClickNavigate} />
          {total > 0 ? (
            <Group justify="center" my="md">
              <Pagination
                total={Math.ceil(total / Number(size))}
                value={Number(page)}
                onChange={(value) => {
                  const currentParams = Object.fromEntries(searchParams.entries());
                  setSearchParams(
                    cleanParams({
                      ...currentParams,
                      page: String(value),
                    }),
                  );
                }}
              />
            </Group>
          ) : null}
        </C.TableWrap>
      </C.ListBox>
    </div>
  );
};

export default DataPoint;
